import { createSlice } from "@reduxjs/toolkit";
const initialAuthState = {
  EscapeValue: false,
  EditViewMode: "",
};
const ParaMeterReducer = createSlice({
  name: "branch",
  initialState: initialAuthState,
  reducers: {
    updateEscapeValue(state, action) {
      state.EscapeValue = action.payload;
    },
    updateEditView(state, action) {
      state.EditViewMode = action.payload;
    },
  },
});
export const ParaMeterReducerAction = ParaMeterReducer.actions;
export default ParaMeterReducer.reducer;
